import { useMemo } from "react";
import cx from "classnames";

import Box, { BoxProps } from "ds/components/Box";

import styles from "./styles.module.css";
import { CardContext } from "../Context";
import { CardSize } from "../types";

type CardWrapperProps = BoxProps & {
  variant?: "secondary" | "primary";
  size?: CardSize;
  ref?: React.ForwardedRef<HTMLDivElement>;
};

const CardWrapper = ({
  className,
  variant = "primary",
  size = "medium",
  children,
  ref,
  ...restProps
}: CardWrapperProps) => {
  const cardContext = useMemo(() => ({ size }), [size]);

  const elementClass = cx(
    styles.wrapper,
    styles[variant],
    size === "small" && styles.small,
    className
  );

  return (
    <CardContext.Provider value={cardContext}>
      <Box direction="column" className={elementClass} {...restProps} ref={ref}>
        {children}
      </Box>
    </CardContext.Provider>
  );
};

CardWrapper.displayName = "DS.Card.Wrapper";

export default CardWrapper;
